import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Checkbox } from '@awaze/design-system.components.checkbox';
import { Badge } from '@awaze/design-system.components.badge';
const StyledFilter = styled.li `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;
/**
 * The filter component displays a checkbox with a numbered badge to the side to indicate the current number of matches.
 *
 * Its current use is within the filters-list component.
 *
 * Selecting/clicking the filter will trigger a callback function returning the ID and Name of the filter that was clicked.
 */
export const Filter = ({ featureId, featureName, groupId, count, onFilterClick, value, checked, ariaLabel, }) => {
    const onHandleClick = (id, featureName) => {
        onFilterClick({ featureId: id, featureName });
    };
    const displayId = `${groupId}=${featureId}`;
    return (_jsxs(StyledFilter, { children: [_jsx(Checkbox, { id: displayId, name: displayId, value: value.toString(), label: featureName, checked: checked, disabled: count <= 0, onChange: () => onHandleClick(featureId, featureName), "aria-label": ariaLabel }), !checked && _jsx(Badge, { text: count.toString(), colourScheme: "tertiary" })] }));
};
//# sourceMappingURL=filter.js.map